import React from "react";
import { MimaText } from "../../../components";
import { amountFormatter } from "../../../utils/utils";

const P2PBuyerInfo = ({ singleItem }) => {
  //BUYER
  const buyer = singleItem?.buyer;
  const buyerFullname = `${buyer?.firstname} ${buyer?.lastname}`;
  const buyerDebitValue = singleItem.buyerDebitValue;
  const buyerCreditValue = singleItem.buyerCreditValue;
  const buyerStatus = singleItem.buyerStatus;
  const buyerForeignAccount = singleItem.buyerBankInfo.foreign.data;
  const adminBuyerPaymentStatus = singleItem.adminBuyerPaymentStatus;

  return (
    <>
      <MimaText variant="subtitleBold" mb={2} align="center">
        Buyer Info
      </MimaText>
      <div className="modal__beside__grid">
        <MimaText labelTitle="Buyer Name">{buyerFullname}</MimaText>
        <MimaText labelTitle="Buyer Username">{buyer?.username}</MimaText>
        <MimaText labelTitle="Buyer Orders">{buyer?.orders} orders</MimaText>

        <MimaText labelTitle="Buyer Insurance Fee:">
          {amountFormatter(buyerDebitValue?.currencyCode).format(
            singleItem.buyerInsuranceFee
          )}
        </MimaText>
        <MimaText labelTitle="Buyer Debit Value">
          {amountFormatter(buyerDebitValue?.currencyCode).format(
            buyerDebitValue?.amount
          )}
        </MimaText>
        <MimaText labelTitle="Buyer Credit Value">
          {amountFormatter(buyerCreditValue?.currencyCode).format(
            buyerCreditValue?.amount
          )}
        </MimaText>
        <MimaText labelTitle="Buyer Avg Comp. Rate">
          {buyer?.avgCompletionRate} %
        </MimaText>
        <MimaText labelTitle="Buyer Avg Comp. Time">
          {buyer?.avgCompletionTime} mins
        </MimaText>
        <MimaText mb={1} labelTitle="Buyer Payment Status">
          <div
            className={`status  ${buyerStatus === "PAID" ? "status__green" : buyerStatus === "VALIDATION" ? "status__blue" : buyerStatus === "REVERSED" ? "status__grey" : buyerStatus === "FALSE-PAYMENT" ? "status__red" : "status__dark__yellow"}`}
          >
            {buyerStatus}
          </div>
        </MimaText>
        <MimaText mb={1} labelTitle="Admin Buyer Payment Status:">
          <div
            className={`status  ${adminBuyerPaymentStatus === "PAID" ? "status__green" : adminBuyerPaymentStatus === "REVERSED" || adminBuyerPaymentStatus === "NO-RESPONSE-FROM-SELLER" ? "status__grey" : adminBuyerPaymentStatus === "FAILED" ? "status__red" : "status__dark__yellow"}`}
          >
            {adminBuyerPaymentStatus}
          </div>
        </MimaText>
      </div>
      {buyerForeignAccount.length > 0 ? (
        <div>
          <MimaText variant="subtitleBold" mb={1} mt={2}>
            Buyer Bank Info
          </MimaText>
          <MimaText mb={1} labelTitle="Payment Type">
            {singleItem.buyerBankInfo.foreign.paymentType}
          </MimaText>
          {singleItem.buyerBankInfo.foreign.data.map((x) => (
            <>
              <MimaText mb={1} labelTitle={x.label}>
                {x.value}
              </MimaText>
            </>
          ))}
        </div>
      ) : (
        <div>
          <MimaText variant="subtitleBold" mb={2} mt={3}>
            Buyer Bank Info
          </MimaText>

          <MimaText mb={1} labelTitle="Account Name:">
            {singleItem.buyerBankInfo.accountName}
          </MimaText>

          <MimaText mb={1} labelTitle="Account Number:">
            {singleItem.buyerBankInfo.accountNumber}
          </MimaText>

          <MimaText mb={1} labelTitle="Account Currency:">
            {singleItem.buyerBankInfo.currencyCode}
          </MimaText>

          <MimaText mb={1} labelTitle="Bank Name:">
            {singleItem.buyerBankInfo.bank}
          </MimaText>
        </div>
      )}
      {singleItem.buyerPaymentProofUrls.length > 0 && (
        <div>
          <MimaText variant="subtitleBold" mb={2} mt={2}>
            Buyer Payment Proof to Admin
          </MimaText>
          {singleItem.buyerPaymentProofUrls.map((x, i) => (
            <div
              key={i}
              style={{
                width: "100%",
                paddingInline: "3rem",
              }}
            >
              <img src={x} alt="Payment Proof" width="100%" />
              <div>
                <a href={x} download="file.jpg">
                  Download file
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
      {singleItem.adminBuyerPaymentProofUrls.length > 0 && (
        <div>
          <MimaText variant="subtitleBold" mb={2} mt={2}>
            Admin Payment Proof to Buyer
          </MimaText>
          {singleItem.adminBuyerPaymentProofUrls.map((x, i) => (
            <div
              key={i}
              style={{
                width: "100%",
                paddingInline: "3rem",
              }}
            >
              <img src={x} alt="Payment Proof" width="100%" />
              <div>
                <a href={x} download="file.jpg">
                  Download file
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default P2PBuyerInfo;
